export const maxArrayInput = <T extends unknown>(
  limit: number,
  message = 'Too many selection'
) => {
  return (value: Array<T>) =>
    value && value.length > limit ? `${message}. Limit: ${limit}` : undefined;
};
